import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

// import images
import features from "../assets/images/features.png";

AOS.init({
  duration: 1800,
});

const Features = () => {
  return (
    <React.Fragment>
      <section className="section features" id="features">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="sec-hd">
                <span className="heading"></span>
                <h2 className="sec-title">Features of our app</h2>
                <span className="heading"></span>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center align-items-center">
            <Col lg={4} md={10} data-aos="fade-right">
              <div className="features-box text-end">
                <div className="features-icon float-end ms-2">
                  <i className="uil uil-users-alt"></i>
                </div>
                <div className="pe-3 me-5">
                  <h5 className="f-15 text-uppercase">
                    Personalized Employee Insights
                  </h5>
                  <p className="text-muted mt-3">
                    Wolbee delivers tailored insights about each employee,
                    helping managers understand their team members&#39;
                    strengths, preferences, and needs on a deeper level.
                  </p>
                </div>
              </div>

              <div className="features-box mt-5 text-end">
                <div className="features-icon float-end ms-2">
                  <i className="uil uil-envelope-minus"></i>
                </div>
                <div className="pe-3 me-5">
                  <h5 className="f-15 text-uppercase">Daily Data Pushes</h5>
                  <p className="text-muted mt-3">
                    Wolbee sends daily, actionable data directly to managers,
                    ensuring they are always equipped with the most up-to-date
                    information to make informed decisions.
                  </p>
                </div>
              </div>

              <div className="features-box mt-5 text-end">
                <div className="features-icon float-end ms-2">
                  <i className="uil uil-mobile-android-alt"></i>
                </div>
                <div className="pe-3 me-5">
                  <h5 className="f-15 text-uppercase">
                    Actionable Recommendations
                  </h5>
                  <p className="text-muted mt-3">
                    Rather than just presenting data, Wolbee provides clear,
                    actionable recommendations on how managers can respond to
                    the insights, fostering meaningful action and improving
                    employee engagement.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className="text-center">
                <img
                  src={features}
                  className="img-fluid"
                  data-aos="zoom-in"
                  alt=""
                />
              </div>
            </Col>
            <Col lg={4} md={10} data-aos="fade-left">
              <div className="features-box">
                <div className="features-icon float-start me-2">
                  <i className="uil uil-calender"></i>
                </div>
                <div className="ps-3 ms-5">
                  <h5 className="f-15 text-uppercase">
                    Employee Engagement Tools
                  </h5>
                  <p className="text-muted mt-3">
                    Wolbee offers tools to track and boost employee engagement,
                    helping managers recognize contributions, build morale, and
                    foster a positive work environment.
                  </p>
                </div>
              </div>
              <div className="features-box mt-5">
                <div className="features-icon float-start me-2">
                  <i className="uil uil-bolt"></i>
                </div>
                <div className="ps-3 ms-5">
                  <h5 className="f-15 text-uppercase">
                    Team Collaboration Insights
                  </h5>
                  <p className="text-muted mt-3">
                    Wolbee helps managers understand team dynamics and
                    collaboration patterns, providing insights that can improve
                    communication and teamwork, enhancing overall productivity.
                  </p>
                </div>
              </div>
              <div className="features-box mt-5">
                <div className="features-icon float-start me-2">
                  <i className="uil uil-feedback"></i>
                </div>
                <div className="ps-3 ms-5">
                  <h5 className="f-15 text-uppercase">
                    Customizable Insights Dashboard
                  </h5>
                  <p className="text-muted mt-3">
                  Managers can customize their Wolbee dashboard to focus on the metrics and insights most
                  relevant to their  needs, making it easier to track what matters to them most.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Features;
